import axios from 'axios';
import { get, identity } from 'lodash';
import { buildApiV2Url } from './utils/apiUtils';
import { generateApiError } from './utils/apiErrorMessages';

export default (payload, itemDataMapper = identity) =>
  axios
    .post(buildApiV2Url('bulk'), payload)
    .catch(generateApiError())
    .then(resp => get(resp, 'data.data', []).map(itemDataMapper));
